const leaf = (title, path, name) => ({
  name: name || title,
  path,
  meta: { title },
});

export const localDevelopmentMenu = [
  {
    name: "eios",
    path: "/eios/energyStation",
    meta: { title: "系统设置", iconExtPath: "energyStation" },
    children: [
      leaf("场站管理", "/eios/energyStation", "energyStation"),
      leaf("电价类别收费管理", "/eios/priceElectricity", "PriceElectricity"),
      leaf("回路管理", "/eios/adminLoop", "AdminLoop"),
      leaf("设备管理", "/eios/device", "device"),
      leaf("巡检单管理", "/eios/inspectionForm", "inspectionForm"),
      leaf("巡检项管理", "/eios/inspectionItem", "inspectionItem"),
      leaf("试验项管理", "/eios/testItem", "testItem"),
      leaf("操作日志", "/event/operation", "operation"),
      leaf("平台运行日志", "/event/platform", "platform"),
      leaf("单位管理", "/eios/companyInfo", "CompanyInfo"),
      leaf("用户管理", "/eios/user", "user"),
      leaf("角色管理", "/eios/roleAdmin", "RoleAdmin"),
      leaf("菜单管理", "/eios/menuAdministration", "MenuAdministration"),
      leaf("字典管理", "/eios/dictionary", "Dictionary"),
      leaf("采集设备信息管理", "/eios/collection", "Collection"),
      leaf("空调密码管理", "/eios/airConditioning", "AirConditioning"),
      leaf("告警管理", "/eios/allAlarm", "AllAlarm"),
      leaf("源网荷储权限配置", "/eios/ywhcPermission", "YwhcPermission"),
    ],
  },
  {
    name: "OperationManagement",
    path: "/operationManagement/inspectionTask",
    meta: { title: "运维管理", iconExtPath: "inspectionTask" },
    children: [
      leaf("巡检任务", "/operationManagement/inspectionTask", "inspectionTask"),
      leaf("维修任务", "/operationManagement/taskList", "TaskList"),
      leaf("维修记录", "/operationManagement/operationService", "OperationService"),
      leaf("抢修记录", "/operationManagement/operationEmergency", "OperationEmergency"),
      leaf("试验任务", "/operationManagement/testTask", "testTask"),
      leaf("消警记录", "/operationManagement/operationWarning", "OperationWarning"),
      leaf("抢修任务", "/operationManagement/rushRepair", "RushRepair"),
    ],
  },
  {
    name: "Management",
    path: "/assessment/management",
    meta: { title: "考核管理", iconExtPath: "Management" },
  },
  {
    name: "Administration",
    path: "/equipment/administration",
    meta: { title: "资产管理", iconExtPath: "Administration" },
  },
  {
    name: "security",
    path: "/security/control",
    meta: { title: "安全管理", iconExtPath: "Control" },
    children: [
      leaf("灯光联动装置", "/security/control", "Control"),
      leaf("空调联动装置", "/security/conditioning", "Conditioning"),
      leaf("红外探测器", "/security/infrared", "Infrared"),
      leaf("智能门锁", "/security/doorLock", "DoorLock"),
      leaf("声光报警器", "/security/acoustoOptic", "AcoustoOptic"),
      leaf("无线温度传感器", "/security/temperature", "Temperature"),
      leaf("噪声传感器", "/security/noise", "Noise"),
      leaf("变压器温控", "/security/transformer", "Transformer"),
      leaf("特高频局放", "/security/frequency", "Frequency"),
      leaf("变压器声纹", "/security/voicePrint", "VoicePrint"),
      leaf("烟雾传感器", "/security/smoke", "Smoke"),
      leaf("温湿度传感器", "/security/humidity", "Humidity"),
      leaf("SF6+O3传感器", "/security/sf6o3", "sf6o3"),
      leaf("水浸监测", "/security/water", "Water"),
    ],
  },
  {
    name: "PlanAdministration",
    path: "/planAdministration/patrol",
    meta: { title: "计划管理", iconExtPath: "inspectionPlan" },
    children: [
      leaf("巡视计划", "/planAdministration/patrol", "Patrol"),
      leaf("检修计划", "/planAdministration/overhaul", "Overhaul"),
      leaf("培训计划", "/planAdministration/train", "Train"),
      leaf("采购计划", "/planAdministration/purchase", "Purchase"),
      leaf("巡检计划", "/planAdministration/inspectionPlan", "inspectionPlan"),
      leaf("试验计划", "/planAdministration/testPlan", "testPlan"),
      leaf("停电计划", "/planAdministration/blackout", "Blackout"),
    ],
  },
  {
    name: "DailyWork",
    path: "/dailyWork/document",
    meta: { title: "日常办公", iconExtPath: "Document" },
    children: [
      leaf("文档管理", "/dailyWork/document", "Document"),
      leaf("员工通讯录", "/dailyWork/staffAddressBook", "StaffAddressBook"),
      leaf("客户通讯录", "/dailyWork/customerAddressBook", "CustomerAddressBook"),
      leaf("意见反馈", "/dailyWork/feedback", "Feedback"),
      leaf("公告管理", "/dailyWork/notice", "Notice"),
      leaf("消息管理", "/dailyWork/message", "Message"),
    ],
  },
  {
    name: "Library",
    path: "/knowledge/library",
    meta: { title: "知识库", iconExtPath: "Library" },
  },
  {
    name: "Energy",
    path: "/energy/equipment",
    meta: { title: "能源管理", iconExtPath: "Equipment" },
    children: [
      leaf("设备能耗", "/energy/equipment", "Equipment"),
      leaf("变压器", "/energy/energyTransformer", "energyTransformer"),
      leaf("特高频", "/energy/highFrequency", "HighFrequency"),
      leaf("局放", "/energy/partial", "Partial"),
      leaf("碳排分析", "/energy/emissionsCarbonA", "EmissionsCarbonA"),
      leaf("能源运营", "/energy/operations", "Operations"),
    ],
  },
  {
    name: "StatisticsAnalysis",
    path: "/statistics/analysis",
    meta: { title: "统计分析", iconExtPath: "StatisticsAnalysis" },
  },
  {
    name: "YwhcSourceV2",
    path: "/ywhc/source",
    meta: { title: "源侧发电", iconExtPath: "electricity" },
    children: [],
  },
  {
    name: "YwhcGridV2",
    path: "/electricityHome",
    meta: { title: "网侧配电", iconExtPath: "water" },
    children: [],
  },
  {
    name: "YwhcLoadV2",
    path: "/ywhc/load",
    meta: { title: "荷侧负荷", iconExtPath: "gas" },
    children: [],
  },
  {
    name: "YwhcStorageV2",
    path: "/ywhc/storage",
    meta: { title: "储侧储能", iconExtPath: "heating" },
    children: [],
  },
];

export const localDevelopmentPermissions = [
  "*:*:*",
  "btnEdit",
  "btnDelete",
  "btnTable",
  "btnNewCompanyInfo",
  "btnNewAdminLoop",
  "btnNewDictory",
  "btnNewCollection",
  "btnNewMenu",
  "btnNewElectricity",
  "btnNewPassword",
  "btnNewRole",
  "btnTableType",
  "btnBindUsers",
  "btnTemplateDownload",
  "btnInport",
  "btnNewEqu",
  "btnExport",
  "btnModify",
  "wxbtnTaskRelease",
  "wxbtnSubmit",
  "wxbtnEdit",
  "wxbtnImplement",
  "wxbtnApproval",
  "wxbtnComplete",
  "wxbtnStop",
  "wxbtnDelete",
  "btnVoiceprint",
  "btnDoorProhibition",
];
